<div
  class="left-right-list-title my-3"
  role="heading"
  [attr.aria-level]="ariaHeadingLevel"
  i18n="@@itemMetadata-heading-details"
>
  Details
</div>

<span
  *ngIf="!resourceMetadata && !partOfMetadata"
  i18n="@@itemMetadata-status-noDetails"
  class="qa-no-details"
>
  No details found
</span>

<ng-container *ngIf="resourceMetadata || partOfMetadata">
  <rl-resource-metadata
    [metadata]="resourceMetadata"
    class="qa-resource-metadata"
  >
  </rl-resource-metadata>

  <ng-container *ngIf="partOfMetadata">
    <div
      class="left-right-list-title my-3 c-resource-metadata__label qa-item-meta-data__part-of-title"
      role="heading"
      [attr.aria-level]="ariaHeadingLevel"
      i18n="@@itemMetadata-label-partOf"
    >
      Part of {{ resource.part_of.title }}
    </div>

    <rl-resource-metadata
      [metadata]="partOfMetadata"
      [resourceType]="resource.part_of.resource_type"
      class="qa-part-of-metadata"
    >
    </rl-resource-metadata>
  </ng-container>
</ng-container>
